import { Select } from '@mantine/core';
import { useList } from '../api/hooks/useCrud.ts';
import type { Location } from '../api/schemas/entities.ts';

export function LocationSelect({
  value,
  onChange,
  label,
  placeholder,
  required,
}: {
  value: number | null | undefined;
  onChange: (id: number | null) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
}) {
  const { data } = useList<Location>('locations');
  const options = (data ?? [])
    .filter(l => l.id != null)
    .map(l => ({ value: String(l.id), label: l.name ?? `#${l.id}` }));
  return (
    <Select
      label={label}
      placeholder={placeholder}
      data={options}
      value={value == null ? null : String(value)}
      onChange={s => onChange(s == null ? null : Number(s))}
      searchable
      clearable
      required={required}
    />
  );
}

export function locationName(locations: Location[] | undefined, id: number | null | undefined): string {
  if (!locations || id == null) return '';
  return locations.find(l => l.id === id)?.name ?? '';
}
